import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { DistributionOfLandedCostsDetail } from "src/components/Pages/Documents/DistributionOfLandedCosts/components/DistributionOfLandedCostsDetail";
import DistributionOfLandedCostsList from "src/components/Pages/Documents/DistributionOfLandedCosts/components/DistributionOfLandedCostsList";
import { NFLookupDistributionOfLandedCosts } from "src/components/Shared/NewForms/NFLookupDistributionOfLandedCosts";
import { ICreateDistributionOfLandedCostsDto } from "src/components/Pages/Documents/DistributionOfLandedCosts/dtos/CreateDistributionOfLandedCostsDto";
import { DistributionOfLandedCostsService } from "src/services/documents/DistributionOfLandedCostsService";

export const DistributionOfLandedCosts: IAppEntity = {
  entityType: "document",
  title: "Distribution Of Landed Costs",
  pluralTitle: "Distribution Of Landed Costs",
  apiUrl: "DistributionOfLandedCosts",
  apiEnum: ReferenceTypes.DocumentDistributionOfLandedCost,
  getDetailView: (id?: string) => {
    return React.createElement(DistributionOfLandedCostsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(DistributionOfLandedCostsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupDistributionOfLandedCosts, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new DistributionOfLandedCostsService("DistributionOfLandedCosts"),
  getEmptyModel: () => {
    const model: ICreateDistributionOfLandedCostsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      createdDate: new Date(),
      vendorInvoices: [],
      expenses: [],
      products: [],
      documentDate: new Date(),
      status: 0
    };
    return model;
  }
};
